import { useQuery } from "@tanstack/react-query";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
const fetchIsDatanodeConfigured = async () => fetch("GET", qualifyUrl("/datanode/configured"));
const useIsDatanodeConfigured = () => {
  const { data: isDatanodeConfigured, isInitialLoading: isLoading } = useQuery({
    queryKey: ["IsDatanodeConfigured"],
    queryFn: fetchIsDatanodeConfigured
  });
  return {
    isDatanodeConfigured,
    isLoading
  };
};
export default useIsDatanodeConfigured;
